
export default function WhyPartner() {
  return (
    <section id="why-partner" className="py-12 bg-gray-50 relative overflow-hidden">
      {/* Decorative magazine pages on left */}
      <div className="absolute left-0 top-1/2 -translate-y-1/2 hidden lg:block">
        <div className="w-16 h-72 bg-white rounded-r-lg shadow-lg border-r border-t border-b border-gray-200 transform -translate-x-8 rotate-2">
          <div className="h-full p-2 flex flex-col justify-between">
            <div className="space-y-1">
              <div className="h-1.5 bg-gray-200 rounded w-3/4"></div>
              <div className="h-1 bg-gray-100 rounded w-full"></div>
              <div className="h-1 bg-gray-100 rounded w-2/3"></div>
            </div>
            <div className="h-16 bg-gray-100 rounded"></div>
            <div className="space-y-1">
              <div className="h-1 bg-gray-100 rounded w-full"></div>
              <div className="h-1 bg-gray-100 rounded w-4/5"></div>
            </div>
          </div>
        </div>
        <div className="w-12 h-64 bg-white rounded-r-lg shadow-md border-r border-t border-b border-gray-100 transform -translate-x-10 -rotate-1 -mt-56">
          <div className="h-full p-1.5 flex flex-col justify-between opacity-60">
            <div className="h-1 bg-gray-200 rounded w-2/3"></div>
            <div className="h-12 bg-gray-100 rounded"></div>
            <div className="h-1 bg-gray-100 rounded w-full"></div>
          </div>
        </div>
      </div>

      {/* Decorative magazine pages on right */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 hidden lg:block">
        <div className="w-16 h-72 bg-white rounded-l-lg shadow-lg border-l border-t border-b border-gray-200 transform translate-x-8 -rotate-2">
          <div className="h-full p-2 flex flex-col justify-between">
            <div className="space-y-1">
              <div className="h-1.5 bg-gray-200 rounded w-3/4"></div>
              <div className="h-1 bg-gray-100 rounded w-full"></div>
              <div className="h-1 bg-gray-100 rounded w-2/3"></div>
            </div>
            <div className="h-16 bg-gray-100 rounded"></div>
            <div className="space-y-1">
              <div className="h-1 bg-gray-100 rounded w-full"></div>
              <div className="h-1 bg-gray-100 rounded w-4/5"></div>
            </div>
          </div>
        </div>
        <div className="w-12 h-64 bg-white rounded-l-lg shadow-md border-l border-t border-b border-gray-100 transform translate-x-10 rotate-1 -mt-56">
          <div className="h-full p-1.5 flex flex-col justify-between opacity-60">
            <div className="h-1 bg-gray-200 rounded w-2/3"></div>
            <div className="h-12 bg-gray-100 rounded"></div>
            <div className="h-1 bg-gray-100 rounded w-full"></div>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <h2 className="text-4xl font-bold text-center mb-8 text-gray-900">
          Why partner with Harmony Horizon?
        </h2>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm">
              <i className="ri-heart-line text-3xl text-[#6B4EFF]"></i>
            </div>
            <h3 className="text-xl font-semibold mb-3 text-gray-900">
              Families feel more connected
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Give families a tangible way to stay involved in their loved one's daily life. Monthly stories and photos build trust and peace of mind.
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm">
              <i className="ri-trophy-line text-3xl text-[#6B4EFF]"></i>
            </div>
            <h3 className="text-xl font-semibold mb-3 text-gray-900">
              Strengthen your community reputation
            </h3>
            <p className="text-gray-600 leading-relaxed">
              A professionally branded magazine showcases your programs and culture. Families see the care and attention you put into every detail.
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm">
              <i className="ri-time-line text-3xl text-[#6B4EFF]"></i>
            </div>
            <h3 className="text-xl font-semibold mb-3 text-gray-900">
              Simple review, no heavy lifting
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Just 10–15 minutes per month to review the final proof. We handle design, sponsorships, and distribution — you focus on residents.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
